import { constant } from '@/constant';

export type ContextIconVariant = 'filled' | 'outlined';

type IconMap = Record<number, string>;

const FILLED_CONTEXT_ICON_MAP: IconMap = {
  [constant.Context.Type.Text]: 'description',
  [constant.Context.Type.Image]: 'image',
  [constant.Context.Type.Video]: 'videocam',
  [constant.Context.Type.File]: 'attach_file',
  [constant.Context.Type.Link]: 'link',
};

const OUTLINED_CONTEXT_ICON_MAP: IconMap = {
  [constant.Context.Type.Text]: 'o_description',
  [constant.Context.Type.Image]: 'o_image',
  [constant.Context.Type.Video]: 'o_videocam',
  [constant.Context.Type.File]: 'attach_file',
  [constant.Context.Type.Link]: 'o_link',
};

const CONTEXT_ICON_MAP_BY_VARIANT: Record<ContextIconVariant, IconMap> = {
  filled: FILLED_CONTEXT_ICON_MAP,
  outlined: OUTLINED_CONTEXT_ICON_MAP,
};

const CONTEXT_ICON_FALLBACK_BY_VARIANT: Record<ContextIconVariant, string> = {
  filled: 'attachment',
  outlined: 'o_link',
};

export const getContextIconName = (contextType: number, variant: ContextIconVariant = 'filled') => {
  const iconMap = CONTEXT_ICON_MAP_BY_VARIANT[variant];
  return iconMap[contextType] ?? CONTEXT_ICON_FALLBACK_BY_VARIANT[variant];
};
